import { RGLogo } from "components/UI/RGLogo";
import AdTab from "components/ads/AdTab";
import { tabs } from "components/ads/config/tabs";
import RgLogo from "components/icons/RGLogo.svg?react";
import { SearchInput } from "components/UI/SearchInput";
import BurgerMenu from "components/UI/BurgerMenu";
import { BurgerButton } from "components/buttons/BurgerButton/BurgerButton";
import React, { Fragment, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IAppState } from "store/app-state";
import { useDeviceType, deviceTypeEnum } from "hooks/useDeviceType";
import { toggleBurgerMenu } from "store/application/application-action";

import "./MainHeader.scss";

export const MainHeader = () => {
  const dispatch = useDispatch();
  const isSearchBarOpen = useSelector((state: IAppState) => state.application.isSearchBarOpen);
  const isBurgerMenuOpen = useSelector((state: IAppState) => state.application.isBurgerMenuOpen);
  const deviceType = useDeviceType();
  const isDesktop = deviceType === deviceTypeEnum.DESKTOP;

  const handleBurgerMenuButton = useCallback(() => {
    dispatch(toggleBurgerMenu());
  }, [dispatch]);

  return (
    <Fragment>
      {(isDesktop || !isSearchBarOpen) && <RGLogo />}
      <div className="topNav-wrap">
        <div>
          { isDesktop && <AdTab link={tabs.RGCams.link}>Explore <RgLogo width="18" height="12" /> Cams</AdTab> }
        </div>
        <SearchInput/>
        <div>
          { isDesktop && <AdTab link={tabs.LiveSex.link}>Watch Live Sex</AdTab> }
        </div>
        {(isDesktop || !isSearchBarOpen) && <BurgerButton onClick={handleBurgerMenuButton}/>}
      </div>
      {isBurgerMenuOpen && <BurgerMenu />}
    </Fragment>
  );
};
